import { hrefFor } from '../api/href';
import type { Me } from '../credential/api';

/**
 * The bar across the top of every console page: the product, what the page
 * is about, a chip saying where it stands, and who is signed in.
 *
 * `subject` is the assessment's title where the page has one and the landing
 * page's own name otherwise — never an id, which the first live run showed in
 * this position because no route returned a title until `GET /v1/assessments`
 * did (ZD-120). The chip's words are the page's to choose from what `next`
 * says; nothing here reads a state.
 */
export function Masthead({
  subject,
  chip,
  chipOpen = false,
  me,
  onSignOut,
  home = false,
}: {
  subject: string;
  chip: string | null;
  /** The chip in the accent: the person's own turn. */
  chipOpen?: boolean;
  me: Me | null;
  onSignOut: () => void;
  /** Whether the page is the landing page, which has nowhere further up to link to. */
  home?: boolean;
}): React.JSX.Element {
  return (
    <header className="masthead">
      <h1>{home ? 'Zevik' : <a href={hrefFor(window.location.search, null)}>Zevik</a>}</h1>
      <span className="subject">{subject}</span>
      {chip === null ? null : (
        <span className="gate" data-open={chipOpen}>
          {chip}
        </span>
      )}
      {me === null ? null : (
        <span className="who">
          <span className="who__name">{me.display_name}</span>
          <button type="button" className="who__out" onClick={onSignOut}>
            Sign out
          </button>
        </span>
      )}
    </header>
  );
}
